import { Alert, Button } from '@dnx/ui';
import { useQueryClient } from '@tanstack/react-query';
import { Navigate, useNavigate } from '@tanstack/react-router';
import { Check, Copy, Download } from 'lucide-react';
import { useState } from 'react';
import { AuthLayout } from '../components/auth-layout.js';
import { recoveryCodesStore } from '../lib/session.js';

export function RecoveryCodesPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [codes] = useState(() => recoveryCodesStore.take());
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!codes) return <Navigate to="/" />;
  const text = `Domnexus Capilar — códigos de recuperação\nGerados em ${new Date().toLocaleString('pt-BR')}\nCada código funciona uma única vez.\n\n${codes.join('\n')}\n`;

  return (
    <AuthLayout
      title="Guarde seus códigos de recuperação"
      description="Se você perder o celular, estes códigos são a única forma de entrar sem o aplicativo. Eles não serão mostrados de novo."
    >
      <ul className="grid grid-cols-2 gap-2 rounded-xl border border-border bg-surface-muted p-4" aria-label="Códigos de recuperação">
        {codes.map((c) => (
          <li key={c} className="rounded-md bg-surface px-3 py-2 text-center font-mono text-sm tracking-wide text-fg shadow-card">{c}</li>
        ))}
      </ul>
      <div className="mt-3 flex gap-2">
        <Button variant="secondary" size="sm" onClick={() => { void navigator.clipboard.writeText(text); setCopied(true); }}>
          {copied ? <Check className="size-4 text-success" /> : <Copy className="size-4" />} {copied ? 'Copiado' : 'Copiar'}
        </Button>
        <Button variant="secondary" size="sm" onClick={() => {
          const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
          const a = Object.assign(document.createElement('a'), { href: url, download: 'domnexus-codigos-de-recuperacao.txt' });
          a.click();
          URL.revokeObjectURL(url);
        }}>
          <Download className="size-4" /> Baixar .txt
        </Button>
      </div>
      <Alert tone="warning" className="mt-6">Guarde em um gerenciador de senhas ou papel em local seguro. Não envie por WhatsApp ou e-mail.</Alert>
      <label className="mt-6 flex cursor-pointer items-start gap-3 text-sm text-fg">
        <input type="checkbox" className="mt-0.5 size-4 accent-[var(--dnx-primary)]" checked={saved} onChange={(e) => setSaved(e.target.checked)} />
        Guardei os códigos em um local seguro
      </label>
      <Button className="mt-5" size="lg" block disabled={!saved}
        onClick={async () => { recoveryCodesStore.set(null); await qc.invalidateQueries({ queryKey: ['auth'] }); void navigate({ to: '/' }); }}>
        Continuar para o painel
      </Button>
    </AuthLayout>
  );
}
